<template>
  <v-data-iterator
    :items="users.data"
    :page.sync="c_page"
    :items-per-page.sync="c_size"
    :server-items-length="users.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <v-row no-gutters class="pa-2">
        <v-col cols="3" v-for="(user, index) in slot.items">
          <im-user-card
            :user="user"
            :key="index"
            @edit="$emit('edit', user)"
          />
        </v-col>
      </v-row>
    </template>
  </v-data-iterator>
</template>

<script>

  export default {

    components: {
      'im-user-card': () => import('@/components/Admin/User/UserCard')
    },

    props: {
      users: Object
    },

    data: () => ({
      pagination: {
        page: 1,
        size: 32,
      },
      itemsPerPageOptions: [16, 32, 64]
    }),

    computed: {

      c_page: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: val,
            size: this.pagination.size,
          })
        }
      },

      c_size: {
        get() {
          return this.pagination.size;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: this.pagination.page,
            size: val
          })
        }
      }

    }

  }

</script>